<template>
  <LazyHomeCommonLayout :is-blog-banner="true">
    <template #content>
      <section id="blog" class="blog subPageSection">
        <div class="backBg"></div>
        <div class="containerMain">
          <div class="cardList blogList">
            <div class="subPageTitle">
              <h1>{{ t("home-blog-title") }}</h1>
            </div>
            <section class="listTopArea">
              <div class="listCount">
                <span>{{ blogPage.totalElementCount.toString().padStart(2, '0') }}</span>
                {{ t("home-blog-count", blogPage.totalElementCount) }}
              </div>
            </section>
            <section v-if="isInit" class="cardListArea">
              <template v-if="blogList.length > 0">
                <ul class="cardListWrap">
                  <LazyBlogCard v-for="(blog, index) in blogList" :key="index" :blog="blog"/>
                </ul>
                <div v-if="!blogPage.last" class="loadBtn" @click.stop="getArticleList()" @dblclick.prevent>{{ t("common-load-more") }}</div>
              </template>
              <div v-else class="listNone">{{ t("home-blog-none") }}</div>
            </section>
          </div>
        </div>
      </section>
      <div id="mainFooter"></div>
      <!-- pc 네비게이션 펼칠 때 on 클래스 -->
    </template>
  </LazyHomeCommonLayout>
</template>

<script setup lang="ts">
import {computed, onBeforeUnmount, onMounted, ref} from 'vue';
import {useI18n} from 'vue-i18n';
import {useHomeService} from '~/composables/service/useHomeService';
import {ArticleModel} from '~~/package/mapper/home/model/ArticleModel';
import {PageModel} from '~~/package/mapper/common/model/PageModel';
import {RouteName} from '~~/package/enum/RouteName';
import {useSeoMeta} from '~/composables/useSeoMeta';

const { $i18n } = useNuxtApp();
const { t } = useI18n();
const route = useRoute();
const router = useRouter();
const homeService = useHomeService();
const { getCanonical, getHreflangLinks } = useSeoMeta();

const blogList = ref<ArticleModel[]>([]);
const blogPage = ref<PageModel<ArticleModel>>(new PageModel<ArticleModel>());
const isInit = ref(false);

useHead({
  title: 'Blog | Codepresso',
  meta: [
    { name: 'description', content: 'Read the latest Codepresso blog articles on technical hiring, coding assessments, and developer skills.' },
    { name: 'robots', content: 'index,follow' },
  ],
  link: [...getHreflangLinks.value, { rel: 'canonical', href: getCanonical.value }],
})

definePageMeta({
  alias: [
    '/en/home/blog',
    '/ja/home/blog',
    '/ko/home/blog',
    '/vi/home/blog',
  ],
})

const getArticleList = () => {
  homeService
    .getArticleList(blogPage.value.pageNumber + 1, 9, "BLOG", $i18n.locale.value.toUpperCase())
    .then((page) => {
      blogList.value = [...blogList.value, ...page.data];
      blogPage.value = page;
      isInit.value = true;
    });
};

// 구 버전 페이지 링크 처리 (url 쿼리 존재 시)
const handleOldPageLink = () => {
  homeService
    .getArticle({ link: route.query.url as string })
    .then((articleData) => {
      router.replace({ name: RouteName.HomeBlogDetail, params: { blogId: articleData.id } });
    })
    .catch(() => {
      getArticleList();
      router.replace({ ...route, query: {} });
    });
};

onMounted(() => {
  if (route.query.url) {
    handleOldPageLink();
  } else {
    getArticleList();
  }
});
</script>

<style>
@import "~/assets/scss/blog_style.scss";
</style>